const elegibilityDetermination = {
  None: 0,
  NegativeDetermination: 1,
  PositiveDetermination: 2,
};

export default elegibilityDetermination;
